import React from 'react'
import imagenBanner1 from '../img/bannerPrincipal.png'

const QuienesSomos = () => {
  return (
    <>
      <div className='div-banner-imagen'>
        <img src={imagenBanner1} alt='Banner-Scorts' className='img-banner-principal'></img>
      </div>
      <div className='div-container-menu-padre'>
        <h3 className='btn-close-modal' style={{ marginBottom: "2rem", fontFamily: "Newton Howard", color: "#6ADFFF" }}>Quienes somos?</h3>
        <p>
          Somos agencia de  publicidad  para adultos, estamos certificados  ante  entidades comerciales legalmente, tenemos un enfoque específico en prestar
          servicios publicitarios y logísticos a modelos escort y damas de compañía con el fin de contactarlas a encuentros eróticos, sexuales, fetiches,
          compañía tipo novia, acompañamiento a diferentes actividades como pueden ser ejecutivas, party, cena, viaje, evento personal, con personas de su interés,
          también manejamos videollamadas por diferentes portales Skype y telegram , las modelos  de esta categoría  son expresivas a la hora de poder conectar
          en los diferentes intereses de la persona  llevando a cabo así una experiencia única y satisfactoria, contamos con planes creados y pensados
          para ocasiones especiales  como pueden ser salida de amigos , despedida de soltero , día de san Valentín , cumpleaños.
        </p>
        <br />
        <p>
          La modelo que te cautivo es la que llega, tú eliges.
        </p>
        <br />
        <p>
          Nos eliges por llevar el sexo a otro nivel
        </p>
        {
          /*
        <p>
          Somos una de las primeras empresas legales de publicidad que ofrece exclusividad, realismo, experiencias inolvidables para nuestros clientes ya que contamos con un
          equipo calificado para contratar las mejores modelos tanto bellas físicamente e inteligentes, con mucho deseo sexual para ofrecer, también te acompañará a tus
          diferentes actividades estará a la altura de tus eventos.
        </p>
        <br />
        <p>
          Tenemos el objetivo de ser la mejor empresa del país y de Latinoamérica como agencia de publicidad para Escorts, Prepagos, Call girls y Damas de compañía,
          así también ofrecer estabilidad económica, capacitación y más a nuestras modelos por medio de entretenimiento para adultos, compañía y sexo de una forma más
          segura y digna.
        </p>
        <br />
        <p>
          Hacemos filtros de ingreso a nuestras modelos, son totalmente lo que vas a pedir, pedimos calificación luego de tu cita con la modelo, te garantizamos
          seguridad somos agencia legal ante entidades comerciales.
        </p>
        <br />
        <p>
          Hacemos entrevista física en instalaciones adecuadas como oficina, rechazamos rotundamente el abuso a las mujeres, explotación sexual no pedimos fotos al desnudo ni
          entrevistas sexuales, las modelos podrán estar seguras de tratar con un equipo profesional, también nos aseguramos las modelos tengan la mayoría de edad, sea la misma
          persona de las fotos sin filtros, sin editar comprobamos personalmente su físico y personalidad, estén preparadas en las diferentes áreas de vida para asumir su
          actividad adecuadamente y tranquilamente.
        </p>
        <br />
        <p>
          Nos aseguramos por medio de nuestros filtros antes del ingreso de cualquier modelo este en perfecto estado de salud, tenga conocimientos de la vida sexual y los
          cuidados que conlleva, le pedimos a nuestros clientes interesados en solicitar una modelo, sea para compañía o sexo, este consiente de gozar de salud y protección ya
          que nuestras modelos son chicas jóvenes con salud certificada y proyectos de vida.
        </p>
        <br />
        <p>
          Tu identidad e información estará segura, es confidencial para nosotros, datos de clientes como modelos de igual puedes revisar nuestras 
          <Link className='btn btn-link' style={{padding:"0px", textDecoration:"none", color:"#FF1A1A", marginLeft:"3px"}} target='_blank' to="/politicaPrivacidad">política de privacidad</Link>
        </p>
        <br />
        <p>
          Puedes seguirnos en redes sociales y estados de WhatsApp estar al tanto de promociones, modelos vip, encuentros especiales en fechas importantes.<br /><br />
          Puedes pagar en efectivo al momento de verte con la modelo, Nequi, Daviplata , cuenta Ahorro Davivienda por PSE al Nit 901643904-0<br /><br />
          Realizar reservaciones con 2 horas de antelación ya que nuestras modelos deben de arreglarse correctamente para el evento y hay que contar el tiempo de desplazamiento
        </p>
          */
        }
      </div>
    </>
  )
}

export default QuienesSomos